module.exports = __webpack_public_path__ + "media/images/ticket/to_ticket_shop-24a82263b03df02c39dbb045f964cc42.png";